import { render } from "./RevisedLogin.vue?vue&type=template&id=4d3b151e&scoped=true"
import script from "./RevisedLogin.vue?vue&type=script&lang=js"
export * from "./RevisedLogin.vue?vue&type=script&lang=js"

import "./RevisedLogin.vue?vue&type=style&index=0&id=4d3b151e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3b151e"]])

export default __exports__